import { Component, Input, OnInit } from '@angular/core';
import { CategoriaImgFilterService } from '../../shared/services/categoria-img-filter.service';

@Component({
  selector: 'app-ods',
  templateUrl: './ods.component.html',
  styleUrls: ['./ods.component.scss']
})

export class OdsComponent implements OnInit {
  @Input() useSharedLinks: boolean = true; // Flag para usar links compartidos

  // Links por defecto (hardcodeados)
  private defaultOds = [
    {
      id:'1',
      image:'assets/img/ods/1.webp',
      url:'https://www.un.org/sustainabledevelopment/es/poverty/',
    },
    {
      id:'2',
      image:'assets/img/ods/2.webp',
      url:'https://www.un.org/sustainabledevelopment/es/hunger/',
    },
    {
      id:'3',
      image:'assets/img/ods/3.webp',
      url:'https://www.un.org/sustainabledevelopment/es/health/',
    },
    {
      id:'4',
      image:'assets/img/ods/4.webp',
      url:'https://www.un.org/sustainabledevelopment/es/education/',
    },
    {
      id:'5',
      image:'assets/img/ods/5.webp',
      url:'https://www.un.org/sustainabledevelopment/es/gender-equality/',
    },
    {
      id:'6',
      image:'assets/img/ods/6.webp',
      url:'https://www.un.org/sustainabledevelopment/es/water-and-sanitation/',
    },
    {
      id:'7',
      image:'assets/img/ods/7.webp',
      url:'https://www.un.org/sustainabledevelopment/es/energy/',
    },
    {
      id:'8',
      image:'assets/img/ods/8.webp',
      url:'https://www.un.org/sustainabledevelopment/es/economic-growth/',
    },
    {
      id:'9',
      image:'assets/img/ods/9.webp',
      url:'https://www.un.org/sustainabledevelopment/es/infrastructure/',
    },
    {
      id:'10',
      image:'assets/img/ods/10.webp',
      url:'https://www.un.org/sustainabledevelopment/es/inequality/',
    },
    {
      id:'11',
      image:'assets/img/ods/11.webp',
      url:'https://www.un.org/sustainabledevelopment/es/cities/',
    },
    {
      id:'12',
      image:'assets/img/ods/12.webp',
      url:'https://www.un.org/sustainabledevelopment/es/sustainable-consumption-production/',
    },
    {
      id:'13',
      image:'assets/img/ods/13.webp',
      url:'https://www.un.org/sustainabledevelopment/es/climate-change-2/',
    },
    {
      id:'14',
      image:'assets/img/ods/14.webp',
      url:'https://www.un.org/sustainabledevelopment/es/oceans/',
    },
    {
      id:'15',
      image:'assets/img/ods/15.webp',
      url:'https://www.un.org/sustainabledevelopment/es/biodiversity/',
    },
    {
      id:'16',
      image:'assets/img/ods/16.webp',
      url:'https://www.un.org/sustainabledevelopment/es/peace-justice/',
    },
    {
      id:'17',
      image:'assets/img/ods/17.webp',
      url:'https://www.un.org/sustainabledevelopment/es/globalpartnerships/',
    },
  ];

  ods = [...this.defaultOds];

  constructor(private categoriaImgFilterService: CategoriaImgFilterService) {}

  ngOnInit(): void {
    if (this.useSharedLinks) {
      this.updateOdsWithSharedLinks();
    }
  }

  /**
   * Actualiza los links de ODS usando los links compartidos del servicio
   */
  private updateOdsWithSharedLinks(): void {
    const sharedLinks = this.categoriaImgFilterService.getAllOdsLinks();
    this.ods = this.defaultOds.map(odsItem => ({
      ...odsItem,
      url: sharedLinks[odsItem.id] || odsItem.url // Usa el link compartido si existe, sino mantiene el default
    }));
  }
}
